<template>
  <AdminPageView class="bg-light" :loading="loading">
    <div class="container-fluid">
      <h2 class="text-center mb-5">Export {{ travel?.name }}</h2>
      <div class="align-content-start d-flex flex-row flex-wrap gap-4">
        <div>
          <b>Pour exporer les details de l'evenement: Url à mettre dans Excel: </b>
          <a :href="`${VITE_API_ENDPOINT}/admin/exports/travel/${travel?.id}/excel`" target="_blank">{{ VITE_API_ENDPOINT }}/admin/exports/travel/{{ travel?.id }}/excel</a>
        </div>
        <div>
          <b>Pour exporter les participants de l'evenement: Url à mettre dans Excel: </b>
          <a :href="`${VITE_API_ENDPOINT}/admin/exports/travel/${travel?.id}/participants/excel`" target="_blank">{{ VITE_API_ENDPOINT }}/admin/exports/travel/{{ travel?.id }}/participants/excel</a>
        </div>
      </div>
    </div>
  </AdminPageView>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import adminApi from '@/api/adminApi'
import AdminPageView from '@/views/admin/AdminPageView.vue';
import { useNotificationsStore } from '@/stores/notificationStore';

const notificationsStore = useNotificationsStore();
const VITE_API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;

const loading = ref(true);
const travel = ref<AdminTravel>();
const props = defineProps<{ id?: number|null }>();

onMounted(() => {
  if (props.id) {
      adminApi.getTravel(props.id).then((response) => {
        travel.value = response.data;
    }).catch((error: Error) => {
      notificationsStore.notifyError('Erreur lors de la récupération des événements', error.message);
    }).finally(() => {
      loading.value = false;
    });
  } else {
    travel.value = <AdminTravel>{};
    loading.value = false;
  }
});
</script>
